import React from "react";
import { isMobile } from "react-device-detect";
// import agendaimg from '../../public/img/agenda.png'

const Agenda2026 = () => {
  return (
    <section className="agenda-section">
      <div className="agenda-container">
        {/* <h2 className="agenda-title">Agenda 2026</h2> */}

        <div className="agenda-card">
          <img
            src={isMobile ? '/img/agendamob26.jpg' : '/img/agenda.jpg'}
            alt="Agenda 2026"
            className="agenda-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Agenda2026;